import React from 'react';
import { m } from 'framer-motion';
import { StarIcon, PackageCheckIcon, ShoppingBagIcon, TimerIcon, TrendingUpIcon, UsersIcon, SparklesIcon, TruckIcon, HammerIcon } from 'lucide-react';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const stats = [{
  icon: StarIcon,
  value: '4.9/5',
  label: '+320 Manitas y Carpinteros facturando'
}, {
  icon: PackageCheckIcon,
  value: '+5.200',
  label: 'Piezas vendidas en España'
}, {
  icon: ShoppingBagIcon,
  value: '+1.200',
  label: 'Ventas en Wallapop y Etsy'
}, {
  icon: TimerIcon,
  value: '-12 horas',
  label: 'Ahorradas a la semana'
}, {
  icon: TrendingUpIcon,
  value: '+400€',
  label: 'Ingresos extra promedio / mes'
}];
const trustBadges = [{
  icon: UsersIcon,
  title: 'Para Todos los Niveles',
  text: 'No necesitas ser maestro ebanista. Si sabes usar una cinta métrica y una sierra, puedes hacerlo.'
}, {
  icon: SparklesIcon,
  title: 'Diseño que el Mercado PAGA',
  text: 'Olvida competir con IKEA. Productos con estética Nórdica y Montessori que decoradores en España compran con gusto.'
}, {
  icon: TruckIcon,
  title: 'Logística Inteligente',
  text: 'Productos diseñados para enviarse por Correos o Wallapop por apenas 5€, maximizando tu beneficio neto.'
}, {
  icon: HammerIcon,
  title: 'Herramientas que YA TIENES',
  text: 'Taladro, caladora, lijadora. Eso es todo. Sin máquinas industriales de 3.000€.'
}];
export function TrustStats() {
  return <section className="border-y border-brown/10 bg-bg-secondary py-8 sm:py-10" data-id="element-212" data-mp="1rv2i7ktj17gc">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-213" data-mp="1wrszuckzcb3v">
        <ScrollHintTable minWidth="760px" data-id="element-214" data-mp="1wqhui8bvyvan">
          <div className="grid grid-cols-5 divide-x divide-brown/15" data-id="element-215" data-mp="1is1grxflw4j0">
            {stats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-216" data-mp="1mtmzw0iqhf1n" data-mpi={i}>
                <stat.icon size={22} className="text-brown" data-id="element-217" data-mp="293dabbzyq1n2" />
                <span className="font-heading text-xl font-bold text-ink sm:text-2xl" data-id="element-218" data-mp="293vcsqd7xc3f">{stat.value}</span>
                <span className="text-xs text-muted sm:text-sm" data-id="element-219" data-mp="24aaeex7pqg3p">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>

        <p className="mt-6 text-center font-heading text-sm font-bold uppercase tracking-wider text-success" data-id="element-220" data-mp="1vc88q4d1aza3">
          ✓ El Estándar de Rentabilidad para el Artesano Moderno
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-221" data-mp="1ld94qz37rrtf">
          {trustBadges.map((badge, i) => <m.div key={badge.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 rounded-2xl border border-brown/20 bg-white p-5 shadow-card" data-id="element-222" data-mp="1gexw2ronnncs" data-mpi={i}>
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-brown/10" data-id="element-223" data-mp="3nb1jd2nnc847">
                <badge.icon size={20} className="text-brown" data-id="element-224" data-mp="3s21h2a4lau7r" />
              </div>
              <div data-id="element-225" data-mp="3s4454om6md9u">
                <p className="font-heading text-sm font-bold text-ink" data-id="element-226" data-mp="v6z90lo1b3z">{badge.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-227" data-mp="30alm9ssvq16g">{badge.text}</p>
              </div>
            </m.div>)}
        </div>
      </div>
    </section>;
}